import React from "react";
import { BarChart3, TrendingUp, Shield, Smartphone, Calendar, Star, Gift, Users, Zap, Camera, Instagram, Wifi } from "lucide-react";

const ProSection = () => {
    const navegarA = (seccion) => {
        if (seccion === 'registro') {
            window.location.href = '/signup';
        }
    };

    const generateClientNumber = () => {
        return `MX${Math.floor(Math.random() * 900000) + 100000}PRO`;
    };

    const clientNumber = generateClientNumber();

    return (
        <section id="pro" className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-green-900 relative overflow-hidden">
            {/* Elementos decorativos de fondo */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-green-500/10 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-green-500/5 to-transparent rounded-full"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 relative z-10">
                {/* Header principal */}
                <div className="text-center mb-20">
                    <div className="inline-flex items-center bg-gradient-to-r from-[#14840c] to-green-600 text-white px-6 py-3 rounded-full mb-8 text-lg font-semibold">
                        <Star className="w-5 h-5 mr-2" />
                        Programa Exclusivo
                    </div>

                    <h2 className="text-6xl md:text-7xl font-black text-white mb-6">
                        Conviértete en
                        <span className="block bg-gradient-to-r from-green-400 to-emerald-300 text-transparent bg-clip-text">
                            MiguelMX PRO
                        </span>
                    </h2>

                    <p className="text-xl md:text-2xl text-slate-300 mb-8 max-w-5xl mx-auto leading-relaxed font-medium">
                        MiguelMX® PRO es nuestro programa exclusivo que recompensa tu buena toma de decisiones financieras.
                        <span className="text-green-400 font-bold"> Si ya formas parte de la comunidad Miguel MX, ¡estás a solo un paso de desbloquear beneficios únicos!</span>
                    </p>

                    <div className="inline-flex items-center bg-green-600/20 border border-green-400/30 text-green-300 px-8 py-4 rounded-2xl text-lg font-semibold backdrop-blur-sm">
                        <Zap className="w-6 h-6 mr-3" />
                        Solo necesitas: Contratar y referir servicios
                    </div>
                </div>

                {/* Proceso de cómo volverse PRO */}
                <div className="mb-20">
                    <h3 className="text-4xl font-bold text-white text-center mb-12">
                        ¿Cómo te vuelves PRO?
                    </h3>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                step: "1",
                                title: "Contrata servicios",
                                desc: "Utiliza nuestros servicios de asesoría, seguros o inversiones",
                                icon: BarChart3,
                                color: "blue"
                            },
                            {
                                step: "2",
                                title: "Refiere a otros",
                                desc: "Comparte MiguelMX® con familiares y amigos",
                                icon: Users,
                                color: "green"
                            },
                            {
                                step: "3",
                                title: "Activa beneficios",
                                desc: "Disfruta de cashback, consultas ilimitadas y recompensas exclusivas",
                                icon: Gift,
                                color: "purple"
                            }
                        ].map((step, index) => {
                            const colorMap = {
                                blue: "from-blue-600 to-blue-700",
                                green: "from-green-600 to-green-700",
                                purple: "from-purple-600 to-purple-700"
                            };

                            return (
                                <div key={index} className="relative group">
                                    <div className="bg-white/5 backdrop-blur-lg border border-white/10 p-8 rounded-3xl hover:bg-white/10 transition-all duration-300 group-hover:scale-105">
                                        <div className={`w-16 h-16 bg-gradient-to-r ${colorMap[step.color]} rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                                            <step.icon className="w-8 h-8 text-white" />
                                        </div>
                                        <div className="absolute -top-4 -right-4 w-10 h-10 bg-gradient-to-r from-green-400 to-green-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                                            {step.step}
                                        </div>
                                        <h4 className="text-2xl font-bold text-white mb-4">{step.title}</h4>
                                        <p className="text-slate-300 text-lg leading-relaxed">{step.desc}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Grid de beneficios */}
                <div className="grid lg:grid-cols-2 gap-12 mb-20">
                    {/* Beneficios reales */}
                    <div className="bg-gradient-to-br from-green-600/20 to-emerald-600/20 backdrop-blur-lg border border-green-400/30 p-10 rounded-3xl">
                        <div className="flex items-center mb-8">
                            <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-green-500 rounded-xl flex items-center justify-center mr-4">
                                <Gift className="w-6 h-6 text-white" />
                            </div>
                            <h3 className="text-3xl font-bold text-white">Beneficios Reales</h3>
                        </div>

                        <div className="space-y-6">
                            {[
                                "Gorra oficial Black Clover MiguelMX®",
                                "Cashback en tus contrataciones para usar en nuevos servicios o merch",
                                "Consultas ilimitadas con tu asesor personal",
                                "Acceso exclusivo a servicios premium",
                                "Merch y recompensas limitadas"
                            ].map((benefit, index) => (
                                <div key={index} className="flex items-start space-x-4">
                                    <div className="w-6 h-6 bg-green-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                        <Star className="w-4 h-4 text-green-900" />
                                    </div>
                                    <span className="text-green-100 text-lg font-medium">{benefit}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Multiplica tu impacto */}
                    <div className="bg-gradient-to-br from-blue-600/20 to-purple-600/20 backdrop-blur-lg border border-blue-400/30 p-10 rounded-3xl">
                        <div className="flex items-center mb-8">
                            <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-purple-500 rounded-xl flex items-center justify-center mr-4">
                                <TrendingUp className="w-6 h-6 text-white" />
                            </div>
                            <h3 className="text-3xl font-bold text-white">Multiplica tu Impacto Financiero</h3>
                        </div>

                        <div className="space-y-6">
                            {[
                                "Tus referidos generan beneficios para ti",
                                "Tu dinero trabaja doble: soluciones a la medida + recompensas"
                            ].map((benefit, index) => (
                                <div key={index} className="flex items-start space-x-4">
                                    <div className="w-6 h-6 bg-blue-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                        <Zap className="w-4 h-4 text-blue-900" />
                                    </div>
                                    <span className="text-blue-100 text-lg font-medium">{benefit}</span>
                                </div>
                            ))}
                        </div>

                        {/* Sección de activar cashback */}
                        <div className="mt-10 p-6 bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20">
                            <h4 className="text-xl font-bold text-white mb-4 flex items-center">
                                <Instagram className="w-5 h-5 mr-2" />
                                Activa tu Cashback
                            </h4>
                            <div className="space-y-3 text-slate-300">
                                <p className="flex items-center"><Camera className="w-4 h-4 mr-2 text-pink-400" /> Sube una historia en Instagram con tu gorra MiguelMX®</p>
                                <p className="flex items-center"><span className="w-4 h-4 mr-2 text-pink-400">@</span> Etiqueta a @miguelmx_fin</p>
                                <p className="flex items-center"><span className="w-4 h-4 mr-2 text-green-400">✓</span> Consulta con tu asesor los modelos disponibles</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tarjeta digital siempre visible */}
                <div className="text-center mb-16">
                    <h3 className="text-4xl font-bold text-white mb-8">
                        Tu tarjeta digital PRO - Empieza a obtener cashback
                    </h3>

                    <div className="max-w-md mx-auto">
                        {/* Tarjeta digital */}
                        <div className="relative group cursor-pointer">
                            <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 rounded-3xl blur opacity-75 group-hover:opacity-100 transition duration-300"></div>
                            <div className="relative bg-gradient-to-br from-[#14840c] via-green-600 to-emerald-700 p-8 rounded-3xl shadow-2xl overflow-hidden">
                                {/* Elementos decorativos de la tarjeta */}
                                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
                                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-12 -translate-x-12"></div>

                                <div className="relative z-10">
                                    {/* Logo y NFC */}
                                    <div className="flex justify-between items-start mb-8">
                                        <div>
                                            <h4 className="text-white text-2xl font-black">MiguelMX®</h4>
                                            <p className="text-green-200 text-sm font-semibold">PRO MEMBER</p>
                                        </div>
                                        <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                            <Wifi className="w-6 h-6 text-white transform rotate-90" />
                                        </div>
                                    </div>

                                    {/* Número de cliente */}
                                    <div className="mb-6">
                                        <p className="text-green-200 text-xs font-medium mb-1">NÚMERO DE CLIENTE</p>
                                        <p className="text-white text-xl font-mono tracking-wider">{clientNumber}</p>
                                    </div>

                                    {/* Información del titular */}
                                    <div className="flex justify-between items-end">
                                        <div>
                                            <p className="text-green-200 text-xs font-medium mb-1">MIEMBRO DESDE</p>
                                            <p className="text-white font-semibold">08/2025</p>
                                        </div>
                                        <div className="text-right">
                                            <div className="flex items-center text-white">
                                                <Star className="w-4 h-4 mr-1 text-white-400" />
                                                <span className="text-sm font-bold">PRO</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className="text-green-400 text-sm mt-4 font-medium">
                            ¡Obten tu tarjeta!
                        </p>
                    </div>
                </div>

                {/* Botones de acción */}
                <div className="flex flex-col sm:flex-row gap-6 justify-center">
                    <button
                        onClick={() => navegarA('registro')}
                        className="group bg-gradient-to-r from-[#14840c] to-green-600 text-white px-12 py-6 rounded-2xl font-bold text-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-2xl hover:shadow-green-500/25 hover:scale-105 flex items-center justify-center"
                    >
                        <Smartphone className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform" />
                        Acceder a MiguelMX PRO
                    </button>
                    <button className="group border-2 border-white/30 text-white px-12 py-6 rounded-2xl font-bold text-xl hover:bg-white hover:text-slate-900 transition-all duration-300 backdrop-blur-sm flex items-center justify-center">
                        <Calendar className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform" />
                        Solicitar Demostración
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ProSection;